/* eslint-disable prettier/prettier */
import { decorate, observable, action } from 'mobx';

const WIDTH_STORAGE_KEY = 'swb-chatbot-width';
const DEFAULT_WIDTH = 400;
const MIN_WIDTH = 300;

function readStoredWidth() {
  try {
    const v = parseInt(localStorage.getItem(WIDTH_STORAGE_KEY), 10);
    const maxWidth = Math.floor(window.innerWidth * 0.5);
    return v >= MIN_WIDTH && v <= maxWidth ? v : DEFAULT_WIDTH;
  } catch (_) {
    return DEFAULT_WIDTH;
  }
}

// Shared chatbot UI state — allows MainLayout to react to panel open/close
class ChatBotStore {
    isShowing = false;
    panelWidth = readStoredWidth();

    toggleChat = () => {
        this.isShowing = !this.isShowing;
    }

    closeChat = () => {
        this.isShowing = false;
    }

    setPanelWidth = (width) => {
        const maxWidth = Math.floor(window.innerWidth * 0.5);
        const clamped = Math.max(MIN_WIDTH, Math.min(maxWidth, width));
        this.panelWidth = clamped;
        try { localStorage.setItem(WIDTH_STORAGE_KEY, String(clamped)); } catch (_) { /* noop */ }
    }
}

decorate(ChatBotStore, {
    isShowing: observable,
    panelWidth: observable,
    toggleChat: action,
    closeChat: action,
    setPanelWidth: action,
});

// Singleton so every consumer shares the same state
const chatBotStore = new ChatBotStore();
export { MIN_WIDTH, DEFAULT_WIDTH };
export default chatBotStore;
